var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStorelogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.577,
    height: 23.133,
    viewBox: "0 0 24.577 23.133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "store",
    d: "M37.67,10.084a4.273,4.273,0,0,1-.547.036,3.959,3.959,0,0,1-2.941-1.31,3.967,3.967,0,0,1-5.892,0,3.962,3.962,0,0,1-5.887,0,3.962,3.962,0,0,1-2.948,1.31,4.405,4.405,0,0,1-.548-.036A3.521,3.521,0,0,1,16.563,4.69l2.59-4.1A1.277,1.277,0,0,1,20.235,0h16.12a1.276,1.276,0,0,1,1.08.593l2.589,4.1a3.517,3.517,0,0,1-2.354,5.395Zm.19,1.432c.154-.023.375-.059.556-.1v8.828a2.894,2.894,0,0,1-2.892,2.892H21.066a2.893,2.893,0,0,1-2.892-2.892V11.413a4.176,4.176,0,0,0,.541.1h.005a5.594,5.594,0,0,0,.735.05,5.4,5.4,0,0,0,1.61-.244v6.027H35.524V11.327a5.5,5.5,0,0,0,1.6.239,5.6,5.6,0,0,0,.736-.05Z",
    transform: "translate(-16.006)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorelogo);
export default __webpack_public_path__ + "static/media/store logo.3de6b9950a827446a88d737903885f50.svg";
export { ForwardRef as ReactComponent };